import { LoadingPage } from "$components/loading/loading-page";
import { useUser } from "$global-providers/user-provider";
import { gql } from "@apollo/client";
import { Role } from "elephant-web/gql";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useCheckIfHasPriceListQuery } from "./__generated__/page.gql";
import { linkToCreatePriceList, linkToPriceList } from "./links";

gql`
  query checkIfHasPriceList($facilityId: ID) {
    priceListV2 {
      priceListMeta(input: { facilityId: $facilityId }) {
        id
      }
    }
  }
`;

/**
 * Responsible for checking if we already have a price list, and rerouting to
 * the appropriate page.
 */
export const Root: FC = () => {
  const navigate = useNavigate();
  const { facilityId, role: roleName } = useUser();
  const { data, loading } = useCheckIfHasPriceListQuery({
    variables: { facilityId: roleName === Role.Admin ? null : facilityId },
  });

  useEffect(() => {
    if (!loading && data) {
      if (data.priceListV2.priceListMeta?.id) {
        navigate(linkToPriceList(data.priceListV2.priceListMeta.id));
      } else {
        navigate(linkToCreatePriceList());
      }
    }
  }, [data, loading, navigate]);

  return <LoadingPage />;
};
